<template>
    <div>
        <span>{{ roleNames }}</span>
    </div>
</template>

<script>
import _ from 'lodash'

export default {
    props: ['row'],

    data() {
        return {
            roleNames: this.row.role_names.map(_.startCase).join(', '),
        }
    },
}
</script>
